import React from 'react';
import { Link } from 'react-router-dom';

const HeaderGlass = () => {
  return (
    <header className="header-glass" role="banner" aria-label="Логотип Хочувлето">
      <Link to="/" className="header-glass__link" aria-label="На главную">
        <img src="/wism_logo.png" alt="Хочувлето" className="header-glass__img" />
      </Link>
    </header>
  );
};

export default HeaderGlass;
